import React, { useEffect, useState } from 'react'
import RenderHtml, {
  HTMLElementModel,
  HTMLContentModel,
  defaultSystemFonts,
} from 'react-native-render-html'
import { SafeAreaView, useWindowDimensions, ViewStyle, ActivityIndicator, View } from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'

import { convertFromJSON } from '@trivie/tiptap/src/convert'
import VideoRenderer from './video-renderer'
import ImageRenderer from './image-renderer'
import { Text } from '../text'
import { color } from '../../theme/color'
import AudioRenderer from './audio-renderer'
import { Instance } from 'mobx-state-tree'
import { Branding } from '@trivie/core/src/models/Branding'

const customHTMLElementModels = {
  video: HTMLElementModel.fromCustomModel({
    tagName: 'video',
    mixedUAStyles: {
      borderRadius: 12,
    },
    contentModel: HTMLContentModel.block,
  }),
  audio: HTMLElementModel.fromCustomModel({
    tagName: 'audio',
    mixedUAStyles: {
      borderRadius: 12,
    },
    contentModel: HTMLContentModel.block,
  }),
}

const renderers = {
  audio: AudioRenderer,
  video: VideoRenderer,
  img: ImageRenderer,
}

const renderersProps = {
  img: {
    enableExperimentalPercentWidth: true,
  },
}

interface InfoCard {
  style: ViewStyle
  branding: Instance<typeof Branding>
  containerStyle: ViewStyle
}
export const InfoCard = (props: any) => {
  const { hideTitle, containerStyle, card, footer, style, branding } = props
  const { width } = useWindowDimensions()
  const { text_color } = branding

  const tagsStyles = {
    h1: {
      marginBottom: 4,
      color: text_color,
      fontSize: 24,
    },
    h2: {
      marginBottom: 4,
      color: text_color,
    },
    h3: {
      marginBottom: 4,
      color: text_color,
    },
    ul: {
      color: text_color,
      marginTop: 4,
      marginBottom: 4,
    },
    ol: {
      color: text_color,
      marginTop: 8,
      marginBottom: 4,
    },
    li: {
      bottom: 2.0,
      margin: 0,
      paddingLeft: 4,
      color: text_color,
    },
    p: {
      marginTop: 4,
      marginBottom: 4,
      color: text_color,
    },
    img: {
      borderRadius: 12,
    },
  }

  const [html, setHtml] = useState('')
  const systemFonts = [...defaultSystemFonts, 'Inter']

  useEffect(() => {
    if (card?.card_json) {
      setHtml(convertFromJSON(card.card_json.nodes))
    }
  }, [card?.card_json])

  if (!card) {
    return null
  }

  return (
    <>
      {html ? (
        <View style={CONTAINER}>
          <ScrollView
            style={{ alignSelf: 'center', ...style, height: '100%', maxWidth: 800, width: '100%' }}
            contentContainerStyle={{ ...containerStyle, paddingBottom: 40 }}
          >
            {!hideTitle && (
              <Text text={card.card_name} style={{ color: color.white }} variant="headline" />
            )}
            <RenderHtml
              contentWidth={width}
              tagsStyles={tagsStyles}
              systemFonts={systemFonts}
              source={{ html }}
              customHTMLElementModels={customHTMLElementModels}
              renderers={renderers}
              renderersProps={renderersProps}
            />
          </ScrollView>
          {footer && <SafeAreaView style={{ margin: 20 }}>{footer}</SafeAreaView>}
        </View>
      ) : (
        <View style={{ ...style, ...containerStyle, height: '100%', justifyContent: 'center' }}>
          <ActivityIndicator />
        </View>
      )}
    </>
  )
}

const CONTAINER: ViewStyle = {
  height: '100%',
  maxWidth: 800,
  width: '100%',
  alignSelf: 'center',
  display: 'flex',
}
